<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<!--
 * @Description: 预览操作项
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- 操作项 -->
  <template v-if="fileType('pdf') || fileType('img')">
    <div class="page-navigation" v-if="fileType('pdf')">
      <span class="preview-action-item margin-r-s" @click="changePage('prev')">
        <jw-tooltip :content="$t('上一页')">
          <qfei-icon-circle-up-outlined />
        </jw-tooltip>
      </span>

      <span
      >第
        <jw-input-number :style="{ width: '50px' }" v-model="currentPage" :max="totalPages" :min="1" :formatter="(event) => formatter(event)" @blur="changePage('pageTo')" @keydown.enter="changePage('pageTo')" />
        {{ $t('页') }}/ {{ totalPages }} {{ $t('页') }}</span
      >
      <span class="preview-action-item margin-l-s" @click="changePage('next')">
        <jw-tooltip :content="$t('下一页')">
          <qfei-icon-circle-down-outlined />
        </jw-tooltip>
      </span>
    </div>

    <span class="preview-action-item" @click="handleZoom('in')">
      <jw-tooltip :content="$t('放大')">
        <qfei-icon-enlarge-outlined />
      </jw-tooltip>
    </span>
    <span class="preview-action-item" @click="handleZoom('out')">
      <jw-tooltip :content="$t('缩小')">
        <qfei-icon-shrink-outlined />
      </jw-tooltip>
    </span>
    <template v-if="fileType('img')">
      <span class="preview-action-item" @click="handleRotate">
        <jw-tooltip :content="$t('旋转')">
          <qfei-icon-rotating-outlined />
        </jw-tooltip>
      </span>
      <span class="preview-action-item" @click="toggleDisplayMode">
        <jw-tooltip :content="!isOriginalSize ? $t('原始尺寸') : $t('适应页面')">
          <!-- 原始尺寸 -->
          <qfei-icon-original-scale-outlined v-if="!isOriginalSize" />
          <!-- 适应页面 -->
          <qfei-icon-self-adaption-outlined v-else />
        </jw-tooltip>
      </span>
    </template>
    <div class="preview-action-line">
      <span class="action-line"> | </span>
    </div>
  </template>

  <span class="preview-action-item download-item" @click="handleDownload"> <qfei-icon-download-outlined /> {{ $t('下载') }} </span>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import useXlUpload from '@/hooks/upload';
import { QfeiIconRotatingOutlined, QfeiIconOriginalScaleOutlined, QfeiIconShrinkOutlined, QfeiIconEnlargeOutlined, QfeiIconDownloadOutlined, QfeiIconCircleUpOutlined, QfeiIconCircleDownOutlined, QfeiIconSelfAdaptionOutlined } from '@qfei-design/icons-vue';
const { setUrl, getFileType, downloadFile } = useXlUpload();
import { useUploadStore } from '@/store';
const uploadStore = useUploadStore();
const props = defineProps({
  activeFile: {
    //当前文件
    type: Object,
    default: () => {}
  },
  isOriginalSize: {
    // 是否为原始尺寸模式
    type: Boolean,
    default: false // 确保默认显示为适应页面
  },
  scale: {
    // 当前缩放比例
    type: Number,
    default: 1
  }
});
const currentPage = ref(1); //当前页码
const totalPages = computed(() => uploadStore.totalPages); //总数
const emit = defineEmits(['cb', 'displayModeChange']);
const getFileItem = computed(() => {
  return props.activeFile;
});
const fileType = (type) => {
  return getFileType(getFileItem.value?.name || '', type);
};
watch(
  () => uploadStore.currentPage,
  () => {
    currentPage.value = uploadStore.currentPage;
  },
  { immediate: true }
);
//跳转到指定页
const formatter = (value) => {
  if (!value) return 1;
  return value;
};

/**
 * 切换显示模式（原始尺寸/适应页面）
 */
const toggleDisplayMode = () => {
  const newMode = !props.isOriginalSize;
  emit('displayModeChange', newMode);
};

/**
 * 通用缩放控制方法
 * @param {string} type - 缩放操作类型：'in'（放大）、'out'（缩小）
 */
const handleZoom = (type) => {
  let newScale = props.scale; // 初始值为父组件传递的当前缩放比例

  // 根据操作类型计算新的缩放比例
  switch (type) {
    case 'in':
      newScale = Math.min(props.scale + 0.1, 2); // 放大不超过2倍（避免超出上限）
      break;
    case 'out':
      newScale = Math.max(props.scale - 0.1, 0.1); // 缩小不低于0.1倍（避免低于下限）
      break;
    default:
      return; // 无效类型直接返回，不执行后续操作
  }

  // 只有缩放比例变化时，才触发回调
  if (newScale !== props.scale) {
    emit('cb', 'zoom', { scale: newScale });
  }
};

const rotateAngle = ref(0);
const handleRotate = () => {
  // 旋转角度

  if (rotateAngle.value >= 270) {
    rotateAngle.value = 0;
    emit('cb', 'rotate', { rotateAngle: rotateAngle.value });
    return;
  }
  rotateAngle.value += 90;
  emit('cb', 'rotate', { rotateAngle: rotateAngle.value });
};

const getUrl = computed(() => {
  return setUrl(getFileItem.value, 1);
});
//下载
const handleDownload = () => {
  downloadFile(getUrl.value, getFileItem.value.name);
};

// 通用页面切换方法：direction 可选值 'prev'（上一页）、'next'（下一页）、'pageTo'（跳转指定页）
const changePage = (direction) => {
  if (direction == 'pageTo') {
    emit('cb', direction, { currentPage: currentPage.value });
    return;
  }
  // 根据方向计算目标页码
  const targetPage = direction == 'prev' ? currentPage.value - 1 : currentPage.value + 1;

  // 校验目标页码合法性（1 ≤ 目标页码 ≤ 总页数）
  if (targetPage >= 1 && targetPage <= totalPages.value) {
    currentPage.value = targetPage;
    emit('cb', 'pageChange', { currentPage: currentPage.value });
  }
};
</script>
